import React, { useCallback, useMemo } from 'react';
import { Pressable, View } from 'react-native';
import { Header } from '@react-navigation/stack';
import { Feather } from '@expo/vector-icons';

import { useTheme } from '../../theme';

/**
 * Stack header for screens not restyled yet: the default header with the menu
 * button always last on the right, after any action the screen sets through
 * navigation.setOptions({ headerRight }) (e.g. "Add photo", "Create ticket").
 * Used as the stack's `header` option.
 */
const StackHeader = (props) => {
	const { options, navigation } = props;
	const { theme: { ui: { colors, space, touch } } } = useTheme();
	const screenHeaderRight = options.headerRight;

	const headerRight = useCallback(headerRightProps => (
		<View style={{ flexDirection: 'row', alignItems: 'center' }}>
			{screenHeaderRight ? screenHeaderRight(headerRightProps) : null}
			<Pressable
				onPress={() => navigation.toggleDrawer()}
				accessibilityRole="button"
				accessibilityLabel="Menu"
				style={{
					width: touch.min,
					height: touch.min,
					marginRight: space.xs + 2,
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<Feather name="menu" color={colors.icon} size={22} />
			</Pressable>
		</View>
	), [colors.icon, navigation, screenHeaderRight, space.xs, touch.min]);
	const headerOptions = useMemo(() => ({ ...options, headerRight }), [headerRight, options]);

	return <Header {...props} options={headerOptions} />;
};

export default StackHeader;
